import { ProductData } from "@/common/types/product.type";
import { ProductCategoryData } from "@/common/types/productCategory.type";
import { z } from "zod";

export const productDistribution = z.object({
  id: z.string().optional().nullable(),
  product: z.custom<ProductData>(),
  total_value: z.string().optional().nullable(),
});

export const productCategoryDistributionSchema = z.object({
  id: z.string().optional().nullable(),
  product_category: z.custom<ProductCategoryData>(),
  total_value: z.string().optional().nullable(),
  products_distributions: z.array(productDistribution),
});

export const createGovernmentAllocationDistributionSchema = z.object({
  total_value: z.string().optional().nullable(),
  product_categories_distributions: z.array(productCategoryDistributionSchema),
});

export const productDistributionQuantity = z.object({
  id: z.string().optional().nullable(),
  product: z.custom<ProductData>(),
  total_quantity: z.string().optional().nullable(),
});

export const productCategoryDistributionQuantitySchema = z.object({
  id: z.string().optional().nullable(),
  product_category: z.custom<ProductCategoryData>(),
  total_quantity: z.string().optional().nullable(),
  products_distributions: z.array(productDistributionQuantity),
});

export const createGovernmentAllocationDistributionQuantitySchema = z.object({
  total_quantity: z.string().optional().nullable(),
  product_categories_distributions: z.array(productCategoryDistributionQuantitySchema),
});

export const getGovernmentAllocationDistributionSchema = (isConsumptionControlledByQuantity?: boolean) => {
  return isConsumptionControlledByQuantity
    ? createGovernmentAllocationDistributionQuantitySchema
    : createGovernmentAllocationDistributionSchema
}

export type GovernmentAllocationProductDistributionValidationSchema = z.infer<typeof productDistribution>;
export type GovernmentAllocationProductCategoryDistributionValidationSchema = z.infer<typeof productCategoryDistributionSchema>;
export type CreateGovernmentAllocationDistributionValidationSchema = z.infer<typeof createGovernmentAllocationDistributionSchema>;

export type GovernmentAllocationProductDistributionQuantityValidationSchema = z.infer<typeof productDistributionQuantity>;
export type GovernmentAllocationProductCategoryDistributionQuantityValidationSchema = z.infer<typeof productCategoryDistributionQuantitySchema>;
export type CreateGovernmentAllocationDistributionQuantityValidationSchema = z.infer<typeof createGovernmentAllocationDistributionQuantitySchema>;
